var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNaverBlog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 39 38"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 19.5,
  cy: 18.999,
  r: 17.417,
  fill: "#8C919F"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.913 17.379a.682.682 0 1 0 0 1.365.682.682 0 0 0 0-1.365M20.657 17.309a.736.736 0 1 0 .001 1.471.736.736 0 0 0 0-1.471"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26.763 10.586H12.238a2.655 2.655 0 0 0-2.653 2.656v8.63a2.655 2.655 0 0 0 2.653 2.657h5.13l1.745 4.116s.12.356.41.356c.292 0 .411-.356.411-.356l1.746-4.116h5.083a2.655 2.655 0 0 0 2.653-2.656v-8.63a2.655 2.655 0 0 0-2.653-2.657m-10.949 7.63c-.008 1.577-1.637 1.622-1.637 1.622-.63 0-.986-.418-.986-.418v.284h-1.187v-4.9s-.005-.001 0-.002v.002c.074.012 1.187-.002 1.187-.002v1.873c.278-.477 1.085-.468 1.085-.468 1.757.164 1.537 2.008 1.537 2.008zm2.09-1.858v3.355h-1.16v-3.321c0-.452-.561-.578-.561-.578v-1.17c1.855.075 1.721 1.714 1.721 1.714m2.753 3.482c-1.076 0-1.947-.803-1.947-1.793s.871-1.794 1.947-1.794 1.947.804 1.947 1.794-.871 1.793-1.947 1.793m6.363 0s.017 1.704-1.713 1.704h-.527v-1.103h.318s.727.067.718-1.055c0 0-.141.454-1.16.454 0 0-1.447-.103-1.447-1.515v-.536s.034-1.464 1.621-1.58c0 0 .626-.068 1.012.45v-.358h1.178v3.54"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.174 17.324a.72.72 0 1 0 .002 1.44.72.72 0 0 0-.002-1.44"
})));
export default SvgNaverBlog;